import { SyntheticEvent } from 'react';

import { AppIcon } from '@backrs_ui/common-ui';

import { Box, Chip, SxProps, Tab, Tabs, Theme, useMediaQuery } from '@mui/material';

type HorizontalTabsProps = Readonly<{
  setValue: (arg0: number) => void;
  tabs: string[];
  value: number;
  schoolName: string;
}>;

export function HorizontalTabs({ setValue, tabs, value, schoolName }: HorizontalTabsProps) {
  const isMediumScreen = useMediaQuery('(max-width: 1201px)');

  const handleChange = (e: SyntheticEvent, newValue: number) => {
    e.preventDefault();
    setValue(newValue);
  };

  return (
    <Box sx={containerSx}>
      <Tabs value={value === -1 ? 0 : value} sx={tabsSx} onChange={handleChange}>
        {tabs.map((t) => (
          <Tab key={t} label={t} sx={tabSx} />
        ))}
      </Tabs>
      <Chip
        variant="pill"
        size="lg"
        type={isMediumScreen ? 'only' : 'leading'}
        label={schoolName}
        icon={<AppIcon iconName="ArrowUp" diameter="12px" color="Warning/500" />}
        sx={chipSx}
        onClick={() => setValue(-1)}
      />
    </Box>
  );
}

const tabSx: SxProps<Theme> = ({ typography }) => ({
  ...typography['text-md-semibold'],
  textTransform: 'none',
});

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  borderBottom: `1px solid ${backrs.colors['Colors/Foreground/fg-quaternary']}`,
  alignItems: 'flex-start',
  flexWrap: 'wrap-reverse',
  pt: {
    sm: backrs.spacing['spacing-2xl'],
  },
  display: {
    xs: 'none',
    md: 'flex',
  },
  justifyContent: 'space-between',
  maxWidth: `calc(936px - ${backrs.spacing['spacing-7xl']}) !important`,
  justifyItems: 'flex-end',
  width: '-webkit-fill-available',
  alignSelf: 'flex-end',
  position: 'sticky',
  top: 0,
  backgroundColor: backrs.colors['Beige/25'],
  zIndex: 10,
  mx: {
    xs: backrs.spacing['spacing-4xl'],
  },
  boxSizing: 'border-box',
});

const tabsSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-md'],
  textTransform: 'none',
});

const chipSx: SxProps<Theme> = ({ backrs }) => ({
  borderColor: backrs.colors['Warning/400'],
  '& .MuiChip-label': {
    color: backrs.colors['Warning/500'],
    display: {
      xs: 'none',
      lg: 'block',
    },
  },
  backgroundColor: backrs.colors['Colors/Base/White'],
  alignSelf: 'center',
});
